import React from 'react';
import './Restaurantheader.css';

const Restaurantheader = ({ content = {} }) => (
  <section
    className="Restaurantheader"
    style={{ backgroundImage: `url(${process.env.PUBLIC_URL}${content.heroImage || '/restaurant-header.jpg'})` }}
  >
    <div className="Restaurantheader__overlay"></div>

    <div className="Restaurantheader__content">
      <h1>{content.title || 'Restaurant Marketing'}</h1>
      <div className="Restaurantheader__underline"></div>
    </div>
  </section>
);

export default Restaurantheader;

